module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "spinner spinner--rotate-square-6",
    style: (_vm.styles)
  }, [_c('div', {
    staticClass: "inner-square inner-square-1",
    style: (_vm.outerStyles)
  }), _vm._v(" "), _c('div', {
    staticClass: "inner-square inner-square-2",
    style: (_vm.innerStyles)
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6b7ee4e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RotateSquare6.vue
// module id = 160
// module chunks = 1